export default [
  {
    title: 'Benvenuto',
    element: 'body',
    text: 'Benvenuto in Idónea, la tua piattaforma di scambio di immagini mediche. In questo tour ti aiuteremo a iniziare ad usarlo.',
    placement: {
      relativeTo: 'viewport',
      position: 'bottom right'
    }
  },
  {
    title: 'La mia area',
    element: '.file-container',
    text: 'In "La mia area" puoi vedere tutte le cartelle, i documenti e gli studi che hai in Idonia. Trascina qui le cartelle o i file che desideri archiviare in Idonia.',
    placement: {
      relativeTo: 'viewport',
      position: 'center center'
    }
  },
  {
    title: 'pulsante "Nuovo"',
    element: 'button.new',
    text: 'Utilizza questo menu per creare una cartella di contenuti, caricare un file o cartelle sul dispositivo. Puoi anche caricare un intero studio DICOM per visualizzarlo.',
    placement: {
      relativeTo: 'element',
      position: 'left top'
    }
  },
  {
    title: 'File condivisi',
    element: 'a[data-name="shared"]',
    text: 'In "condiviso con me" vedrai i file e le cartelle condivisi da altri utenti.',
    placement: {
      relativeTo: 'element',
      position: 'right bottom'
    }
  }
]



// WEBPACK FOOTER //
// ./src/components/common/tour/tours/desktop/it-IT/regular.js